export default "__VITE_ASSET___hJrLXBD__"